import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { Doughnut } from 'react-chartjs-2'

import { Header, SubHeader, Body, ChartWrapper } from './OnlineDevices.style'
import { BlueBox, NoResults } from '../../../InfoBox'
import { Padding } from '../../..'
import { colors } from '../../../../constants'

const WorstStores = ({ isEmpty, loading, online, offline, t }) => {
    const numDevices = online + offline
    const offlinePerc = offline / numDevices
    return (
        <BlueBox loading={loading} noResults={isEmpty}>
            <Padding fullHeight>
                <Header>
                    {t('Online Devices')}
                    <SubHeader>{`${offline}/${numDevices} ${((1 - offlinePerc) * 100).toFixed()}%`}</SubHeader>
                </Header>
                <Body color="#fff">
                    {isEmpty && <NoResults />}
                    {!isEmpty && (
                        <ChartWrapper>
                            <Doughnut
                                data={{
                                    color: colors.white,
                                    labels: [t('Online'), t('Offline')],
                                    datasets: [
                                        {
                                            data: [online, offline],
                                            backgroundColor: [colors.bluelight, colors.bluedark],
                                            borderWidth: 0,
                                            defaultFontColor: 'white',
                                        },
                                    ],
                                }}
                                options={{
                                    legend: {
                                        display: true,
                                        labels: {
                                            fontColor: 'white',
                                        },
                                        position: 'bottom',
                                    },
                                    maintainAspectRatio: false,
                                    responsive: true,
                                    defaultFontColor: 'white',
                                    scales: {
                                        xAxes: [
                                            {
                                                display: false,
                                            },
                                        ],
                                        yAxes: [
                                            {
                                                display: false,
                                            },
                                        ],
                                    },
                                }}
                            />
                        </ChartWrapper>
                    )}
                </Body>
            </Padding>
        </BlueBox>
    )
}

WorstStores.propTypes = {
    isEmpty: PropTypes.bool,
    loading: PropTypes.number,
    online: PropTypes.number,
    offline: PropTypes.number,
    t: PropTypes.func.isRequired,
}

WorstStores.defaultProps = {
    isEmpty: true,
    loading: null,
    online: 0,
    offline: 0,
}

export default withTranslation()(WorstStores)